import { OktaAuth } from '@okta/okta-auth-js'
import axios from 'axios'
import { config } from '../Config'

const authClient = new OktaAuth({
    issuer: config.OktaIssuer,
    clientId: config.OktaClientID,
    redirectUri: window.location.origin,
    pkce: true,
    // offline_access is required for Okta to issue a refresh token alongside the access token
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    // Renew via the refresh_token grant instead of the hidden-iframe silent renew, so renewal
    // keeps working even when third-party/iframe cookies are blocked or the Okta SSO session has lapsed
    useRefreshTokens: true,
    tokenManager: {
        autoRenew: true,
        // renew a bit before actual expiry so in-flight API calls don't race an expiring token
        expireEarlySeconds: 300
    },
    // https://github.com/okta/okta-auth-js#transformauthstate
    transformAuthState: async (oktaAuth, authState) => {
        if (!authState.isAuthenticated) {
          return authState
        }

        // Extra requirement: user must have valid Okta SSO session
        const user = await oktaAuth.token.getUserInfo()
        authState.isAuthenticated = !!user // convert to boolean
        authState.users = user // also store user object on authState
        return authState
      }
})

// Every entry point sets the shared axios Authorization header once at load time from
// authClient.getAccessToken(). Without this, a background renewal (silent or via refresh
// token) never reaches axios: the next API call sends the now-stale token, gets a 401, and
// the app's 401 interceptor signs the user out even though their session is still valid.
authClient.tokenManager.on('renewed', (key, newToken) => {
    if (key === 'accessToken' && newToken?.accessToken) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${newToken.accessToken}`
    }
})

export default authClient